mutation ReorderTrainingModules($moduleIds: [ID!]!) {
  reorderTrainingModules(input: { moduleIds: $moduleIds }) {
    trainingModules {
      id
      position
    }
  }
}
